import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const NationalProgramDetails = ({ data }) => {
    return (
        <div>
            <section className="event-details pt-120">
                <Container>
                    <Row>
                        <Col md={12} lg={6}>
                            <h3>{data.EventTitle}</h3>
                            <p>{data.EventContent}</p>
                        </Col>
                        <Col md={12} lg={6}>
                            <img src={data.EventImagePath} alt="" className="img-fluid" />
                        </Col>
                    </Row>
                </Container>
            </section>
            <div className="event-infos pt-20 pb-90">
                <Container>
                    <Row>
                        <Col md={12} lg={4} className="mb-30">
                            <div className="event-infos__single background-secondary">
                                <h3>Venue</h3>
                                <p>{data.EventDescription}</p>
                                <ul className="list-unstyled event-infos__list">
                                    <li>{data.StartDate}</li>
                                    <li>{data.StartTime} {data.EndTime}</li>
                                    <li>{data.EventLocation}</li>
                                </ul>
                                {/* <div className="event-infos__social">
                                    <a href="#none">
                                        <i className="fab fa-twitter"></i>
                                    </a>
                                    <a href="#none">
                                        <i className="fab fa-facebook-square"></i>
                                    </a>
                                    <a href="#none">
                                        <i className="fab fa-pinterest-p"></i>
                                    </a>
                                    <a href="#none">
                                        <i className="fab fa-instagram"></i>
                                    </a>
                                </div> */}
                            </div>
                        </Col>
                        <Col md={12} lg={4} className="mb-30">
                            <div className="google-map__event">
                                <div dangerouslySetInnerHTML={{ __html: data.GoogleMabLink }} />
                            </div>
                        </Col>
                        <Col md={12} lg={4} className="mb-30">
                            <div className="event-infos__single background-special">
                                <h3>Organizer</h3>
                                <p>{data.ContactPersonDetails}</p>
                                <ul className="list-unstyled event-infos__list event-infos__list-has-icons">
                                    {data.ContactPersonMobileNo ? <li>
                                        <i className="azino-icon-telephone"></i>
                                        <a href="tel:6668880000">{data.ContactPersonMobileNo}</a>
                                    </li>
                                        : ''}
                                    {data.ContactPersonEmailid ? <li>
                                        <i className="azino-icon-email"></i>
                                        <a href="mailto:info@azino.com">{data.ContactPersonEmailid}</a>
                                    </li>
                                        : ''}
                                    {data.EventLocation ? <li>
                                        <i className="azino-icon-pin"></i>
                                        {data.EventLocation}
                                    </li>
                                        : ''}
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default NationalProgramDetails;
